import { types as sdkTypes } from 'sharetribe-flex-sdk';

const { UUID } = sdkTypes;

export const getSimulatedBooking = (bookingDates) => {
  const { bookingStart, bookingEnd, dateType } = bookingDates;

  return {
    id: new UUID('00000000-0000-0000-0000-000000000000'),
    type: 'booking',
    attributes: {
      seats: 1,
      start: new Date(bookingStart),
      end: new Date(bookingEnd),
      displayStart: new Date(bookingStart),
      displayEnd: new Date(bookingEnd),
      state: 'accepted',
      dateType,
    },
  };
};
